<script>
  import { extractBinderSourceInfo, toShortPath } from '../../lib/logic/url-parser.js';
  import { navigate } from '../../lib/stores/router.svelte.js';

  let inputValue = $state('');
  let isValid = $state(false);

  function handleInput() {
    const url = inputValue.trim();
    // A cube is a Project's source, never a binder: it reads as invalid here.
    isValid = url !== '' && extractBinderSourceInfo(url) !== null;
  }

  function handlePaste() {
    // Allow paste to complete before checking
    setTimeout(attemptAutoLoad, 0);
  }

  function handleKeydown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      attemptAutoLoad();
    }
  }

  function attemptAutoLoad() {
    handleInput();
    const url = inputValue.trim();
    const sourceInfo = extractBinderSourceInfo(url);
    if (sourceInfo) {
      const shortPath = toShortPath(sourceInfo);
      if (shortPath) {
        navigate('binder', { binderUrl: url, shortPath });
      }
    }
  }
</script>

<div class="input-section">
  <img src="/bb_logo.svg" alt="" class="logo" />
  <h1 class="title">Binder Browser</h1>
  <label class="label" for="urlInput">
    Create a virtual binder from any Moxfield, Scryfall, Archidekt, or ManaBox URL
  </label>
  <div class="input-wrapper">
    <input
      type="url"
      id="urlInput"
      class="url-input"
      placeholder="Paste your deck URL here..."
      bind:value={inputValue}
      oninput={handleInput}
      onpaste={handlePaste}
      onkeydown={handleKeydown}
    />
    <span class="checkmark" class:visible={isValid}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        width="20"
        height="20"
      >
        <path
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
          clip-rule="evenodd"
        />
      </svg>
    </span>
  </div>
</div>

<style>
  .input-section {
    max-width: 28rem;
    margin: 0 auto 3rem;
    padding: 1rem;
    animation: fadeInDown 0.6s ease-out;
  }

  .logo {
    display: block;
    width: 80px;
    height: 80px;
    margin: 0 auto 12px;
  }

  .title {
    font-size: 3.1rem;
    font-family: 'Georgia', serif;
    font-weight: 700;
    letter-spacing: -0.02em;
    background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .label {
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    margin-bottom: 0.75rem;
  }

  .input-wrapper {
    position: relative;
  }

  .url-input {
    width: 100%;
    padding: 0.75rem;
    padding-right: 2.5rem;
    border: 1px solid #d1d5db;
    border-radius: 0.5rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    transition:
      border-color var(--dur-base) var(--ease-standard),
      box-shadow var(--dur-base) var(--ease-standard);
    font-size: 1rem;
    font-family: inherit;
    box-sizing: border-box;
  }

  .url-input:hover {
    border-color: #9ca3af;
    box-shadow:
      0 1px 3px 0 rgba(0, 0, 0, 0.1),
      0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }

  .url-input:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);
  }

  .url-input::placeholder {
    color: #9ca3af;
    transition: color 0.2s ease;
  }

  .url-input:focus::placeholder {
    color: #d1d5db;
  }

  .checkmark {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%) scale(0.8);
    color: #22c55e;
    opacity: 0;
    transition:
      opacity 0.3s ease-in-out,
      transform 0.3s ease-in-out;
    pointer-events: none;
  }

  .checkmark.visible {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 640px) {
    .title {
      font-size: 2.5rem;
    }

    .input-section {
      margin-top: 1.5rem;
      margin-bottom: 2rem;
    }
  }
</style>
